export const OBSERVATION_RADIUS_METERS = 20;
export const MAX_COLLAPSE_COMMIT_DISTANCE_METERS = 20.01;
export const OBSERVATION_CHARGE_PER_SECOND = 2.8;
